import React from 'react';
import ReactImageFallback from "react-image-fallback";
import config from '../../../config';
import common from '../../../common';

const ClubsFilterListElement = (props) => {
    const { el, teamIDs } = props;
    const teamID = el.TID;
    const isSelected = teamIDs.indexOf(teamID) > -1;
    const teamImg = config.UEFAImgBase + `teams/logos/140x140/${teamID}.png`;
    const className = common.makeClasses({
        'si-active': isSelected
    });
    return <li
        className={className}
        key={el['TID']}
        onClick={(e) => props.onClubFilterApply(el, e)}>
        <div className="si-custom-chkbox">
            <input type="checkbox" {...{ checked: isSelected }} />
            <div className="si-check-mark"></div>
        </div>
        <div className="si-club-img si-flexBox">
            <ReactImageFallback
                src={teamImg}
                initialImage={config.playerImgBase + "default_jersey@2x.png"}
                fallbackImage={config.playerImgBase + "default_jersey@2x.png"}
                alt="" />
            <span>{el['WebName']}</span>
        </div>
    </li>
};
export default ClubsFilterListElement;


// WEBPACK FOOTER //
// ./src/components/onboarding/filters/ClubsFilterListElement.js